import React from "react";
import { UserInfoContext } from "src/hoc/UserInfoProviderContext";

export const useUserInfo = () => React.useContext(UserInfoContext);
